import React, { useEffect } from 'react';
import locales from '../locales/locales';

function Img(props) {
    var currentLang = locales.getLanguage();

    useEffect(() => {
        var lazyImages = [].slice.call(document.querySelectorAll(".lazy-loaded"));
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting ) {
                    let lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.classList.remove("lazy");
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        }, {
            threshold: 1.0,
            trackVisibility: true,
            delay: 500

        });
        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    }, [currentLang])

    return (
        <>
            <figure>
                <img className="lazy-loaded lazy" src={props.lazySrc} data-src={props.src} alt={props.alt} />
                {props.legend ? <figcaption>{props.legend}</figcaption> : null}
            </figure>
        </>
    )
}

export default Img;